<template>
  <div>
    <v-card class="sf-card"
            flat>
      <div class="sf-card__header">
        <div>
          <div class="sf-card__subtitle">{{ $t('personalDetails') }}</div>
          <h2 class="sf-card__title">{{ customerName }}</h2>
        </div>
      </div>
      <v-card-text class="sf-card__body">
        <v-alert class="mb-6"
                 text
                 type="error"
                 v-bind:value="validationAlert">
          {{ $t('pleaseCompleteTheForm') }}
        </v-alert>
        <v-form ref="form">
          <v-row class="sf-form-row">
            <v-col cols="12">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('companyName')"
                            v-model="customer.companyName" />
            </v-col>
          </v-row>

          <h3 class="sf-section-title mt-6">{{ $t('contact') }}</h3>

          <v-row class="sf-form-row">
            <v-col cols="12" sm="6">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('givenName')"
                            v-bind:rules="[ rules.required, rules.capitalFirstLetter ]"
                            v-model="customer.givenName" />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('familyName')"
                            v-bind:rules="[ rules.required, rules.capitalFirstLetter ]"
                            v-model="customer.familyName" />
            </v-col>
          </v-row>

          <h3 class="sf-section-title mt-6">{{ $t('address') }}</h3>

          <v-row class="sf-form-row">
            <v-col cols="12">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('streetAddress')"
                            v-bind:rules="[ rules.required ]"
                            v-model="customer.streetAddress" />
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('postalCode')"
                            v-bind:rules="[ rules.required ]"
                            v-model="customer.postalCode" />
            </v-col>
            <v-col cols="12" sm="8">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('city')"
                            v-bind:rules="[ rules.required ]"
                            v-model="customer.city" />
            </v-col>
          </v-row>

          <h3 class="sf-section-title mt-6">{{ $t('contactDetails') }}</h3>

          <v-text-field dense hide-details="auto"
                        outlined
                        v-bind:label="$t('email')"
                        v-bind:rules="[ rules.required, rules.validEmailAddress ]"
                        v-model="customer.email" />
        </v-form>
      </v-card-text>
      <v-card-actions v-if="nextStepButton != null || previousStepButton != null">
        <v-btn color="primary"
               outlined
               v-if="previousStepButton != null"
               v-on:click="previousStep">
          <v-icon left>ti-arrow-left</v-icon>
          {{ previousStepButton }}
        </v-btn>
        <v-spacer />
        <v-btn color="accent"
               depressed
               v-if="nextStepButton != null"
               v-on:click="nextStep">
          {{ nextStepButton }}
          <v-icon right>ti-arrow-right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
  export default {
    computed: {
      customerName() {
        if (this.customer.companyName != null && this.customer.companyName.length !== 0) {
          return this.customer.companyName
        }

        if (this.customer.givenName != null && this.customer.givenName.length !== 0 && this.customer.familyName != null && this.customer.familyName.length !== 0) {
          return `${this.customer.givenName} ${this.customer.familyName}`
        }

        return this.$t('unknown')
      },
      rules() {
        return {
          required: v => !!v || this.$t('form.required'),
          capitalFirstLetter: v => !v || /^[A-ZÄÖÜ]/.test(v) || this.$t('form.mustStartWithCapitalLetter'),
          validEmailAddress: v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$t('form.pleaseEnterAValidEmailAddress')
        }
      }
    },
    methods: {
      nextStep() {
        this.$emit('next-step')
      },
      previousStep() {
        this.$emit('previous-step')
      },
      validate() {
        return this.$refs.form.validate()
      }
    },
    name: 'CustomerPersonalDetailsCard',
    props: {
      customer: Object,
      nextStepButton: String,
      previousStepButton: String,
      validationAlert: Boolean
    }
  }
</script>

<i18n>
  {
    "de": {
      "address": "Adresse",
      "city": "Stadt",
      "contact": "Ansprechpartner",
      "contactDetails": "Kontakt",
      "companyName": "Firmenname",
      "customer": "Kunde",
      "email": "E-Mail-Adresse",
      "givenName": "Vorname",
      "familyName": "Nachname",
      "pleaseCompleteTheForm": "Bitte vervollständigen Sie Ihre Angaben.",
      "postalCode": "Postleitzahl",
      "streetAddress": "Straße und Hausnummer",
      "unknown": "Unbekannt",
      "personalDetails": "Persönliche Angaben"
    },
    "en": {
      "address": "Address",
      "city": "City",
      "contact": "Contact",
      "contactDetails": "Contact details",
      "companyName": "Company name",
      "customer": "Customer",
      "email": "Email",
      "givenName": "Given name",
      "familyName": "Family name",
      "pleaseCompleteTheForm": "Please complete the form.",
      "postalCode": "Postal code",
      "streetAddress": "Street address",
      "unknown": "Unknown",
      "personalDetails": "Personal details"
    }
  }
</i18n>